// removed by extract-text-webpack-plugin
module.exports = {"featureLandingPageHeader":"EN1nxdbGNTg210D9zomHv","logo":"_2nw11TbRTa0WuzcpGlmJk0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureLandingPageHeader/FeatureLandingPageHeader.module.scss
// module id = 760
// module chunks = 0